import { CancelToken } from 'axios';
import { dailySessionNotes } from '../constants';
import useAxiosInterceptor from '../../interceptor';

class DailySessionNotesService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getPatientList = (payload: any, cancelToken?: CancelToken) => {
    return this.axiosInstance.get(`${dailySessionNotes?.v2All}`, {
      params: {
        ...payload,
        searchString: payload?.searchString,
      },
      cancelToken,
    });
  };
  createSoapNote = (payload: any) => {
    return this.axiosInstance.put(
      `${dailySessionNotes?.createNotes}/${payload?.patientId}`,
      {},
      {
        params: payload?.params,
      }
    );
  };
  getPatientInfo = (payload: any) => {
    return this.axiosInstance.get(
      `${dailySessionNotes?.index}/${payload?.patientId}/therapy-info`,
      {
        params: payload,
      }
    );
  };
  getOtherPatientInfo = (payload: any, cancelToken?: CancelToken) => {
    return this.axiosInstance.get(`${dailySessionNotes?.otherPatient}`, {
      params: payload,
      cancelToken,
    });
  };
  getDailySessionNotes = (payload: any, cancelToken?: CancelToken) => {
    const patientId = payload?.patientId;
    delete payload?.patientId;
    return this.axiosInstance.get(`${dailySessionNotes?.index}/${patientId}`, {
      params: payload,
      cancelToken,
    });
  };

  checkDailyNotSign = (payload: any) => {
    return this.axiosInstance.put(`${dailySessionNotes?.checkESign}`, null, {
      params: payload,
    });
  };
  updateDailySessionNotes = (payload: any) => {
    return this.axiosInstance.put(
      `${dailySessionNotes?.index}/${payload?.patientId}/notes-id/${payload?.notesId}`,
      payload?.body,
      {
        params: payload?.params,
      }
    );
  };

  getPatientNotesTemplate = (uuid: string) => {
    return this.axiosInstance.get(`${dailySessionNotes.getTemplate}/${uuid}`);
  };

  updateNoteAfterJotformEvent = (payload: object, uuid: string) => {
    return this.axiosInstance.put(`${dailySessionNotes.editNote}/${uuid}`, null, {
      params: {
        ...payload,
      },
    });
  };

  submitESign = (payload: object) => {
    return this.axiosInstance.put(dailySessionNotes.submitEsign, null, {
      params: { ...payload },
    });
  };
}

const dailySessionNotesService = new DailySessionNotesService();

Object.freeze(dailySessionNotesService);

export default dailySessionNotesService;
